import { serverUrl } from "../../config/config";

const authPostHeader = (token) => ({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${token}`
});

const authGetHeader = (token) => ({
    "Authorization": `Bearer ${token}`
});

export const authenticate = (email, password) => {
    return fetch (`${serverUrl}/account/signin`,{
        method: "POST",
        mode: "cors",
        headers:{
            "Content-Type": "application/json"
        },
        body: JSON.stringify({email,password})
    })
}

export const deauthenticate = (token) => {
    return fetch (`${serverUrl}/account/signout`,{
        method: "POST",
        headers: {
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })
}

export const adminAccount = (token) => {
    return fetch (`${serverUrl}/account/myaccount`,{
        method: "GET",
        headers: authGetHeader(token),
        mode: "cors"
    })
}